import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { Challenge } from 'src/types/shared/Challenge';

export const editChallengeGroupScoreWeightingRequest = createAction(
    'editChallengeGroupScoreWeightingRequest',
);
export const editChallengeGroupScoreWeightingSuccess = createAction<Challenge>(
    'editChallengeGroupScoreWeightingSuccess',
);
export const editChallengeGroupScoreWeightingFailure = createAction(
    'editChallengeGroupScoreWeightingFailure',
);

export const editChallengeGroupScoreWeighting = (
    challengeGroupID: number,
    postbody: EditChallengeGroupScoreWeightingRequest,
) => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(editChallengeGroupScoreWeightingRequest());
    try {
        const { data } = await api.patch<EditChallengeGroupScoreWeightingRequest, Challenge>(
            `admin/challengeGroups/${challengeGroupID}/weighting`,
            postbody,
        );

        dispatch(editChallengeGroupScoreWeightingSuccess(data));
    } catch (e: any) {
        handleApiErrors(dispatch, editChallengeGroupScoreWeightingFailure, e);
    }
};

export interface EditChallengeGroupScoreWeightingRequest {
    deploymentScale: number;
    fitWithChallenge: number;
    credibilityCompany: number;
    credibilityTechnology: number;
    fullOrPartialSolution: number;
}
